import khTemplatePurpose from '../../../constants-v2/bookkeeping/kh-template-purpose.js';
import column from '../../abstract/column';
import form from '../../abstract/form.js';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export default {
  actions,
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    description: column({
      label: 'Opis',
      form: form({ required: true, disabled: true }),
    }),
    document_type: column({
      label: 'Typ dokumentu',
      sidebar: ({ item: { purpose } }) => ![khTemplatePurpose.TAX_ACCOUNTS, khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      form: form({
        required: true,
        render: ({ item: { purpose } }) => ![khTemplatePurpose.TAX_ACCOUNTS, khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      }),
    }),
    ledger_account: column({
      label: 'Konto księgowe',
      sidebar: ({ item: { purpose } }) => ![khTemplatePurpose.TAX_ACCOUNTS, khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      form: form({
        render: ({ item: { purpose } }) => ![khTemplatePurpose.TAX_ACCOUNTS, khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      }),
    }),
    reverse_ledger_account: column({
      label: 'Konto przeciwstawne',
      sidebar: ({ item: { purpose } }) => [khTemplatePurpose.AMORTIZATION_DEPRECIATION, khTemplatePurpose.EXCHANGE_RATE_DIFFERENCES].includes(purpose),
      form: form({
        render: ({ item: { purpose } }) => [khTemplatePurpose.AMORTIZATION_DEPRECIATION, khTemplatePurpose.EXCHANGE_RATE_DIFFERENCES].includes(purpose),
      }),
    }),
    output_tax_account: column({
      label: 'Konto "Podatek należny"',
      grid: false,
      sidebar: ({ item: { purpose } }) => [khTemplatePurpose.TAX_ACCOUNTS].includes(purpose),
      form: form({
        render: ({ item: { purpose } }) => [khTemplatePurpose.TAX_ACCOUNTS].includes(purpose),
      }),
    }),
    input_tax_account: column({
      label: 'Konto "Podatek naliczony"',
      sidebar: ({ item: { purpose } }) => [khTemplatePurpose.TAX_ACCOUNTS].includes(purpose),
      grid: false,
      form: form({
        render: ({ item: { purpose } }) => [khTemplatePurpose.TAX_ACCOUNTS].includes(purpose),
      }),
    }),
    suppliers_account: column({
      label: 'Konto dostawców',
      sidebar: ({ item: { purpose } }) => [khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      grid: false,
      form: form({
        render: ({ item: { purpose } }) => [khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      }),
    }),
    customers_account: column({
      label: 'Konto odbiorców',
      grid: false,
      sidebar: ({ item: { purpose } }) => [khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      form: form({
        render: ({ item: { purpose } }) => [khTemplatePurpose.SUPPLIERS_AND_CUSTOMERS_ACCOUNTS].includes(purpose),
      }),
    }),
  },
  vars: vars({
    noItemsText: 'Brak szablonów',
    sidebarLabel: 'Podgląd szablonu',
    onSuccessSave: async ({ $router }) => await $router.push({ name: 'admin-kh-templates' }),
  }),
};
